__turbopack_context__.v({
  "auxInfo": "PriceFilter-module__4fAEaq__auxInfo",
  "currencyIconWrapper": "PriceFilter-module__4fAEaq__currencyIconWrapper",
  "discountSwitch": "PriceFilter-module__4fAEaq__discountSwitch",
  "financeProduct": "PriceFilter-module__4fAEaq__financeProduct",
  "listItem": "PriceFilter-module__4fAEaq__listItem",
  "priceFilter": "PriceFilter-module__4fAEaq__priceFilter",
  "priceInput": "PriceFilter-module__4fAEaq__priceInput",
  "priceInputControl": "PriceFilter-module__4fAEaq__priceInputControl",
  "priceTypeBtns": "PriceFilter-module__4fAEaq__priceTypeBtns",
  "resultCount": "PriceFilter-module__4fAEaq__resultCount",
  "stepperWrapper": "PriceFilter-module__4fAEaq__stepperWrapper",
});
